export default "__VITE_ASSET__C6dd9GLL__"